import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { isEmpty } from 'validation/is-empty.js';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Grid from '@material-ui/core/Grid';
import { IconButton, Fab } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import * as api from '../../../api/api';
import PreviewDeclaration from './PreviewDeclaration';
import FixedPlugin from '../FixedPligin';
import { makeStyles } from '@material-ui/core/styles';
import { history } from '../../../utils/hist';

// import CircularProgress from '@material-ui/core/CircularProgress';
// import { withStyles } from '@material-ui/core/styles';
// import _ from 'lodash'
//own css

const directoryParse = (arr, val) => {
  if (!isEmpty(arr)) {
    const dir = arr.filter(({ value }) => parseInt(value) === parseInt(val));
    return dir.length > 0 ? dir[0].label : '';
  }
  return;
};

// import "./ProfilePage.css";

const useStyles = makeStyles(theme => ({
  buttonPossitioning: {
    position: 'absolute', top: 0, right: 0, zIndex: 1, borderRadius: "1px solid"
  },
  relative: {position: 'relative'}
}))

const Preview = props => {
  const classes = useStyles();
  const { applicant, directories } = props;
  const [open, setOpen] = React.useState(false);
  const [fileDeclaration, setFileDeclaration] = React.useState('');
  const [euSign, setEuSign] = React.useState('');
  const [fixedClasses, setFixedClasses] = React.useState('dropdown show');
  const [docCancelApprove, setCancelApprove] = React.useState('')

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCancelApprove('')
  };

  const createDeclaration = async() => {
    try {
      const {data} = await api.getDocument(props.application.id);
      setFileDeclaration(data);
      setCancelApprove('approve')
      setOpen(true);
    } catch (error) {
      
    }
  }

  const handleFixedClick = euSign => {
    
    
    if (fixedClasses === 'dropdown') {
      setFixedClasses('dropdown show');
    } else {
      setFixedClasses('dropdown' );
    }

    setEuSign(euSign);
  };



  return (
    <Grid container justify="flex-start">
       {/* <FixedPlugin
          fixedClasses={fixedClasses}
          handleFixedClick={handleFixedClick}
        /> */}
     {open && <PreviewDeclaration docCancelApprove={docCancelApprove} activeStep={props.activeStep} euSign={euSign} fileDeclaration={fileDeclaration} handleClose={handleClose} open={open}/>}
      <Grid item xs={12}>
        {/* <Card>
          <CardBody className="cardBody"> */}
        {/* <div className="statementWrapper"> */}
        <React.Fragment>
        <h4 className="text-left mb-2">Перегляд даних заяви</h4>
        <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-start"
              className={classes.relative}
            >
              <Grid item xs={1}>
                <Button justIcon size="sm" className={classes.buttonPossitioning} color="primary" onClick={() => props.setActiveStep(0)}>
                  <Edit />
                </Button>
              </Grid>
            </Grid>
        <div className="row justify-content-start">
          <div className="col-12">
            ПІБ:{' '}
            <strong>
              {' '}
              {applicant.surname} {applicant.name} {applicant.fathername}
            </strong>
          </div>
          <div className="col-12 col-lg-4">
            Категорія заявника:{' '}
            <strong>
              {' '}
              {directoryParse(
                directories.submitterType,
                applicant.i_submittertype
              )}
            </strong>
          </div>

          <div className="col-12 col-lg-3">
            Громадянство:{' '}
            <strong>
              {' '}
              {directoryParse(directories.citizenShip, applicant.nationality)}
            </strong>
          </div>
          <div className="col-12 col-lg-3">
            Дата народження: <strong> {applicant.bithdaydate}</strong>
          </div>

          <div className="col-12 col-lg-2">
            Стать:
            <strong>
              {' '}
              {directoryParse(directories.gender, applicant.gender)}
            </strong>
          </div>
          <div className="col-12 col-lg-4">
            {' '}
            Телефон:<strong>{applicant.telephone}</strong>
          </div>
          <div className="col-12 col-lg-4">
            {' '}
            Електронна адреса: <strong> {applicant.email}</strong>
          </div>
          {/* <div className="col-12"> */}
        </div>
        </React.Fragment>
        <hr />
          <React.Fragment>
          <h4 className="text-left mb-2">Паспортні дані:</h4>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-start"
              className={classes.relative}
            >
              <Grid item xs={1}>
                <Button justIcon size="sm" className={classes.buttonPossitioning} color="primary" onClick={() => props.setActiveStep(1)}>
                  <Edit />
                </Button>
              </Grid>
            </Grid>
            {/* </div> */}

            {/* <div className="col-12 pull-right">
                 
                </div> */}
            <div className="row">
              <div className="col-12 col-lg-4">
                РНОКПП:<strong> {applicant.rnokpp}</strong>
              </div>
              {applicant.rnokpp.length !== 10 && (
                <div className="col-12 col-lg-4">Відмова від РНОКПП</div>
              )}
              <div className="col-12">
                Тип документу:{' '}
                <strong>
                  {directoryParse(
                    directories.documentType,
                    applicant.documenttype
                  )}
                </strong>
              </div>
              <div className="col-12 col-lg-4">
                Серія: <strong> {applicant.series}</strong>
              </div>
              {applicant.unzrNumber && (<div className="col-12 col-lg-4">
                Номер УНЗР: <strong>{applicant.unzrNumber}</strong>
              </div>)}
              {/* <div className="col-12 col-lg-4">
                Номер актового запису:{' '}
                <strong>{applicant.actRecordNumber}</strong>
              </div> */}
              {/* <div className="col-12 col-lg-4">
                Дата актового запису: <strong>{applicant.actRecordDate}</strong>
              </div> */}
              <div className="col-12 col-lg-4">
                Номер документу: <strong>{applicant.documentnumber}</strong>
              </div>
              <div className="w-100" />
              <div className="col-12 col-lg-4">
                Дата видачі документу: <strong>{applicant.dateofissue}</strong>
              </div>
              <div className="col-12 col-lg-4">
                Дата кінця дії документу:
                <strong>{applicant.d_doc_stop}</strong>
              </div>
              <div className="w-100" />
              <div className="col-12 col-lg-4">
                Ким видано документ: <strong>{applicant.issuedby}</strong>
              </div>
            </div>
            {/* <div className="row">
                
                <div className="col-12">
                  
                </div>
              </div> */}
          </React.Fragment>
          {/* </div> */}

          <hr />
          <React.Fragment>
          <h4 className="text-left mb-2">Адреса:</h4>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-start"
              className={classes.relative}
            >
              <Grid item xs={1}>
                <Button justIcon size="sm" className={classes.buttonPossitioning} color="primary" onClick={() => props.setActiveStep(2)}>
                  <Edit />
                </Button>
              </Grid>
            </Grid>
            {/* <h4 className="mt-3">Адреса проживання</h4> */}
            <div className="row">
              <div className="w-100" />
              <div className="col-12 col-lg-4">
                Область:{' '}
                <strong>
                  {directoryParse(
                    directories.region,
                    applicant.adressfact.i_region
                  )}
                </strong>
              </div>
              <div className="col-12 col-lg-4">
                Район:{' '}
                <strong>
                  {directoryParse(
                    directories.district_fact,
                    applicant.adressfact.i_subdivision
                  )}
                </strong>
              </div>
              {/* <div className="w-100"></div> */}
              <div className="col-12 col-lg-4">
                {' '}
                Назва населеного пункту:{' '}
                <strong>
                  {directoryParse(
                    directories.city_fact,
                    applicant.adressfact.i_locality
                  )}
                </strong>
              </div>
              <div className="col-12 col-lg-4">
                Відділення зв&#8217;язку:{' '}
                <strong>
                  {directoryParse(
                    directories.index_fact,
                    applicant.adressfact.i_postindex
                  )}
                </strong>
              </div>
              <div className="col-12 col-lg-8">
                Назва вулиці:{' '}
                <strong>
                  {directoryParse(
                    directories.street_fact,
                    applicant.adressfact.i_street
                  )}
                </strong>
              </div>
              <div className="w-100" />
              <div className="col-12 col-lg-4">
                Будинок:<strong>{applicant.adressfact.c_housing}</strong>
              </div>
              {!isEmpty(applicant.adressfact.c_building) &&
                Number(applicant.adressfact.c_building) !== 0 && (
                  <div className="col-12 col-lg-4">
                    Корпус:
                    <strong>
                      {Number(applicant.adressfact.c_building) === 0
                        ? ''
                        : applicant.adressfact.c_building}
                    </strong>
                  </div>
                )}
              {!isEmpty(applicant.adressfact.c_flat) &&
                Number(applicant.adressfact.c_flat) !== 0 && (
                  <div className="col-12 col-lg-4">
                    Квартира:{' '}
                    <strong>
                      {Number(applicant.adressfact.c_flat) === 0
                        ? ''
                        : applicant.adressfact.c_flat}
                    </strong>
                  </div>
                )}
            </div>
          </React.Fragment>
          <hr />
          <React.Fragment>
          <h4 className="text-left mb-2">Банківські реквізити:</h4>
          <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="flex-start"
            className={classes.relative}
          >
            <Grid item xs={1}>
              <Button justIcon size="sm" className={classes.buttonPossitioning} color="primary" onClick={() => props.setActiveStep(3)}>
                <Edit />
              </Button>
            </Grid>
          </Grid>
          <div className="row">
            <div className="col-12 col-lg-4">
              Рахунок для перерахування коштів:
              <strong> {applicant.p_account}</strong>
            </div>
            <div className="col-12 col-lg-4">
              {' '}
              Назва банківської установи:
              <strong> {applicant.p_name}</strong>
            </div>
            <div className="col-12 col-lg-1 ">
              МФО:<strong> {applicant.p_mfo}</strong>
            </div>
            <div className="col-12 col-lg-2 ">
              ЄДРПОУ:<strong> {applicant.p_edrpou}</strong>
            </div>
          </div>
          </React.Fragment>
          {/* </div> */}
        {/* </div> */}
        <Button
                color="primary"
                // disabled={(applications[0] || {}).state_code >= 20}
                type="submit"
                className="btn100 ml-md-3 mt-3 "
                onClick={createDeclaration}
              >
                Подати заяву
              </Button>
        {/* </CardBody>
        </Card> */}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  directories: state.directories,
  applicant: state.applicant,
  application: state.application
});

const mapDispatchToProps = {};

export default connect(mapStateToProps)(Preview);
